import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class PlcData {
  constructor () {
    instance = instance || this

    this._table = DB.plcData

    return instance
  }

  /**
   * @param [string] options.plcDeviceId
   * @param [string] options.address
   * @param [string] options.type
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      plcDeviceId: options.plcDeviceId,
      address: options.address,
      type: options.type
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async all () {
    return this._table.toArray()
  }

  async update (id, data) {
    return this._table.update(id, {
      address: data.address,
      type: data.type
    })
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async plcId (id) {
    return this._table.where({ plcDeviceId: id }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/plc-data.js